import { render, staticRenderFns } from "./AddUnit.vue?vue&type=template&id=5b05600f&scoped=true"
import script from "./AddUnit.vue?vue&type=script&lang=js"
export * from "./AddUnit.vue?vue&type=script&lang=js"
import style0 from "./AddUnit.vue?vue&type=style&index=0&id=5b05600f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05600f",
  null
  
)

export default component.exports